import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

function buildQueryString(params = {}) {
	const query = new URLSearchParams();
	Object.entries(params).forEach(([key, value]) => {
		if (value === undefined || value === null || value === "") return;
		query.set(key, value);
	});
	return query.toString();
}

export const DispatcherPlanApi = createApi({
	reducerPath: "DispatcherPlan",
	baseQuery: fetchBaseQuery({
		baseUrl: `${process.env.REACT_APP_BACKEND3_URL}/dispatch-plans`,
		credentials: "include",
		prepareHeaders: (headers) => {
			const token = localStorage.getItem("token");
			if (token) {
				headers.set("Authorization", `Bearer ${token}`);
			}
			// Backend resolves the response language from this header (see
			// backend3 middleware/localization.ts) — without it every endpoint
			// silently falls back to English regardless of the app's actual
			// language toggle, since the browser's own Accept-Language reflects
			// OS/browser locale, not localStorage("lang").
			headers.set(
				"Accept-Language",
				localStorage.getItem("lang") === "ar" ? "ar" : "en",
			);
			return headers;
		},
	}),
	tagTypes: ["DispatchPlan"],
	endpoints: (builder) => ({
		getAllDispatchPlan: builder.query({
			query: (params = {}) => {
				const qs = buildQueryString(params);
				return qs ? `?${qs}` : "";
			},
			providesTags: ["DispatchPlan"],
		}),
		getSingleDispatchPlan: builder.query({
			query: (id) => `/${id}`,
			providesTags: (result, error, id) => [{ type: "DispatchPlan", id }],
		}),
		createDispatchPlan: builder.mutation({
			query: (payload) => ({
				url: "",
				method: "POST",
				body: payload,
			}),
			invalidatesTags: ["DispatchPlan"],
		}),
		cancelDispatchPlan: builder.mutation({
			query: (id) => ({
				url: `/${id}/cancel`,
				method: "POST",
			}),
			invalidatesTags: ["DispatchPlan"],
		}),
		reassignDispatchPlan: builder.mutation({
			query: ({ id, ...body }) => ({
				url: `/${id}/bulk-reassign-tasks`,
				method: "POST",
				body,
			}),
			invalidatesTags: ["DispatchPlan"],
		}),
		editDispatchPlan: builder.mutation({
			query: ({ id, ...body }) => ({
				url: `/${id}`,
				method: "PUT",
				body,
			}),
			invalidatesTags: ["DispatchPlan"],
		}),
		activateDispatchPlan: builder.mutation({
			query: ({ id, ...body }) => ({
				url: `/${id}/activate`,
				method: "POST",
				body,
			}),
			invalidatesTags: ["DispatchPlan"],
		}),
	}),
});

export const {
	useGetAllDispatchPlanQuery,
	useGetSingleDispatchPlanQuery,
	useCreateDispatchPlanMutation,
	useCancelDispatchPlanMutation,
	useReassignDispatchPlanMutation,
	useEditDispatchPlanMutation,
	useActivateDispatchPlanMutation,
} = DispatcherPlanApi;
